import {
  GET_BUYER_IDENTITY_SUCCESS,
  GET_BUYER_IDENTITY_ERROR,
  GET_BUYER_IDENTITY
} from "./constants";

const initialState = {
  buyerIdentity: {
    isFetching: false,
    data: {},
    error: ""
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BUYER_IDENTITY:
      return {
        ...state,
        buyerIdentity: {
          data: {},
          error: "",
          isFetching: true
        }
      };
    case GET_BUYER_IDENTITY_SUCCESS:
      return {
        ...state,
        buyerIdentity: {
          data: action.identities,
          isFetching: false,
          error: ""
        }
      };
    case GET_BUYER_IDENTITY_ERROR:
      return {
        ...state,
        buyerIdentity: {
          isFetching: false,
          data: {},
          error: action.err
        }
      };
    default:
      return state;
  }
};
